/* eslint-disable react/no-did-mount-set-state */

import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { noop } from 'lodash';

const LOADING_STATE_NOT_LOADED = 'NOT_LOADED';
const LOADING_STATE_STARTED = 'STARTED';
const LOADING_STATE_LOADED = 'LOADED';

export default createReactClass({
  displayName: 'AsyncScriptLoader',

  propTypes: {
    callback: PropTypes.func,
    loader: PropTypes.func,
    preload: PropTypes.func,
    scriptURL: PropTypes.string,
    children: PropTypes.element,
  },

  getInitialState() {
    return {
      loadingState: LOADING_STATE_NOT_LOADED,
    };
  },

  getDefaultProps() {
    return {
      preload: noop,
      callback: noop,
      loader: () => noop,
    };
  },

  isUnmounted: false,

  handleLoaded() {
    if (this.isUnmounted) {
      return;
    }

    this.setState({
      loadingState: LOADING_STATE_LOADED,
    });
  },

  componentDidMount() {
    if (this.state.loadingState !== LOADING_STATE_NOT_LOADED) {
      return;
    }

    this.props.preload();

    this.setState({
      loadingState: LOADING_STATE_STARTED,
    });

    const loader = this.props.loader();
    loader(this.props.scriptURL, this.handleLoaded);
  },

  componentDidUpdate() {
    if (this.state.loadingState === LOADING_STATE_LOADED) {
      this.props.callback();
    }
  },

  componentWillUnmount() {
    this.isUnmounted = true;
  },

  render() {
    return this.state.loadingState === LOADING_STATE_LOADED ? this.props.children : null;
  },
});
